import { isNotDefined, getSourcePathAccessor } from "../utils";

const defaultOptions = {
  windowSize: 20,
  sourcePath: "close",
};

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);

    const increment = 100 / windowSize;
    const array = [];
    let accum = 0;

    return data.map((d, i) => {
      if (i === 0) {
        return undefined;
      }

      const current = source(d);
      const previous = source(data[i - 1]);

      if (isNotDefined(current) || isNotDefined(previous)) {
        return undefined;
      }

      // Determine if current bar closed up (1) or down (0)
      const up = current > previous ? 1 : 0;

      // Add increment to accumulator if up
      if (up) {
        accum += increment;
      }

      // Push to array
      array.push(up);

      // Remove oldest value when window is full
      if (array.length > windowSize) {
        const oldest = array.shift();
        if (oldest) {
          accum -= increment;
        }
      }

      // Only output value once we have full window
      return array.length === windowSize ? accum : undefined;
    });
  }

  calculator.undefinedLength = () => options.windowSize;

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
